import React from 'react';
import { STRIPE_PRICE_IDS } from '../services/stripe';
import { CheckIcon } from './icons';

interface PricingViewProps {
  onSelectPlan: (priceId: string) => void;
  loadingPlan: string | null;
}

const plans = [
  {
    name: 'Pago Mensual',
    price: '2,99€',
    period: '/mes',
    description: 'Flexibilidad total, cancela cuando quieras.',
    priceId: STRIPE_PRICE_IDS.monthly,
    buttonText: 'Elige Mensual',
    promo: '¡Precio promocional!',
    styles: {
      border: 'border-gray-300 dark:border-border',
      button: 'bg-white dark:bg-surface text-primary border border-primary hover:bg-gray-100 dark:hover:bg-gray-800'
    }
  },
  {
    name: 'Pago Anual',
    price: '2,25€',
    period: '/mes',
    description: 'La opción más popular para un compromiso a largo plazo.',
    priceId: STRIPE_PRICE_IDS.annual,
    buttonText: 'Empieza Ahorrando',
    promo: '¡Ahorra un 25%!',
    styles: {
      border: 'border-secondary',
      button: 'bg-secondary text-white hover:bg-green-600'
    },
    recommended: true,
  },
  {
    name: 'Pago Bianual',
    price: '1,97€',
    period: '/mes',
    description: 'El máximo ahorro para un control total.',
    priceId: STRIPE_PRICE_IDS.biannual,
    buttonText: 'Elige 2 Años',
    promo: '¡Ahorra un 34%!',
    styles: {
      border: 'border-gray-300 dark:border-border',
      button: 'bg-white dark:bg-surface text-primary border border-primary hover:bg-gray-100 dark:hover:bg-gray-800'
    }
  }
];

const features = [
    "Transacciones ilimitadas",
    "Categorización con IA",
    "Análisis de Rentabilidad",
    "Registro por Voz",
    "Seguridad de Nivel Google"
];

const PricingView: React.FC<PricingViewProps> = ({ onSelectPlan, loadingPlan }) => {
  return (
    <div className="w-full max-w-4xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
            {plans.map((plan, index) => (
                <div 
                    key={index}
                    className={`relative bg-light-surface dark:bg-surface rounded-xl p-6 border-2 flex flex-col ${plan.styles.border} ${plan.recommended ? 'transform lg:scale-105' : ''}`}
                >
                    {plan.recommended && (
                        <div className="absolute top-0 -translate-y-1/2 left-1/2 -translate-x-1/2 px-4 py-1 bg-secondary text-white text-xs font-bold rounded-full uppercase tracking-wider">
                            Recomendado
                        </div>
                    )}
                    <div className="flex-grow">
                        <h3 className="text-2xl font-bold text-light-text-primary dark:text-text-primary text-center">{plan.name}</h3>
                        <p className="text-sm text-light-text-secondary dark:text-text-secondary text-center mt-2 h-10">{plan.description}</p>
                        <div className="my-6 text-center">
                            <span className="text-5xl font-extrabold text-light-text-primary dark:text-text-primary">{plan.price}</span>
                            <span className="text-lg font-medium text-light-text-secondary dark:text-text-secondary">{plan.period}</span>
                        </div>
                        <p className="text-center font-semibold text-primary mb-6">{plan.promo}</p>
                    </div>
                    <button
                        onClick={() => onSelectPlan(plan.priceId)}
                        disabled={loadingPlan !== null}
                        className={`w-full py-3 rounded-lg font-bold transition-colors text-lg ${plan.styles.button} disabled:bg-gray-500 disabled:cursor-wait`}
                    >
                        {loadingPlan === plan.priceId ? 'Procesando...' : plan.buttonText}
                    </button>
                </div>
            ))}
        </div>
        <div className="mt-10">
            <h4 className="text-xl font-bold text-center mb-6 text-light-text-primary dark:text-text-primary">Todos los planes incluyen las funcionalidades completas:</h4>
            <div className="flex flex-wrap justify-center gap-x-6 gap-y-3 text-light-text-secondary dark:text-text-secondary">
                {features.map((feature, index) => (
                     <div key={index} className="flex items-center gap-2">
                        <CheckIcon className="w-5 h-5 text-secondary" />
                        <span>{feature}</span>
                    </div>
                ))}
            </div>
        </div>
    </div>
  );
};

export default PricingView;